<div class="animated fadeIn container-fluid"  [formGroup]="form">
    <h4 style="display:inline">{{editTitle}} Solicitud {{CodigoSolicitud}}</h4>
    <div class="row">
        <div class="col-md-12">
            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">

                        <div class="card-header">
                            <i class="fa fa-file-text-o"></i> Certificados Fitosanitarios

                        </div>

                        <div class="card-body-detalle">

                            <div class="row">


                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="NumeroCertificado">Número de Certificado: </label>
                                    <input formControlName="NumeroCertificado" name="NumeroCertificado" readonly title="" class="form-control" id="" type="text" value="{{NumeroCertificado}}">
                                </div>


                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="EstadoCfDescripcion">Estado del Certificado: </label>
                                    <input formControlName="EstadoCfDescripcion" name="EstadoCfDescripcion" readonly title="" class="form-control" id="" type="text" value="{{EstadoCfDescripcion}}">
                                </div>


                            </div>
                            <div class="row">


                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="Codigo">Codigo de Solicitud: </label>
                                    <input formControlName="CodigoSolicitud" name="CodigoSolicitud" readonly title="" class="form-control" id="" type="text" value="{{CodigoSolicitud}}">
                                </div>


                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="EstadoSolicitudExDescripcion">Estado de la Solicitud: </label>
                                    <input formControlName="EstadoSolicitudExDescripcion" name="EstadoSolicitudExDescripcion" readonly title="" class="form-control" id="" type="text" value="{{EstadoSolicitudExDescripcion}}">
                                </div>


                            </div>
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label">Utilizado </label>
                                    <p-toggleButton class="form-control-togglebutton"
                                                    formControlName="CfUtilizado" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times" id="" [(ngModel)]="CfUtilizado"></p-toggleButton>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label">Disponible </label>
                                    <p-toggleButton class="form-control-togglebutton"
                                                    formControlName="CfDisponible" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times" id="" [(ngModel)]="CfDisponible"></p-toggleButton>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
